export const environment = {
    mainDomain: '',
    production: false,
    envName: 'dev',
    use_sentry: false,
    sentry_key: ''
};
